import { useAxios } from '@vueuse/integrations/useAxios';
import { env } from '@/config/env.ts';
import { useRoute, useRouter } from 'vue-router';
import axios, { type AxiosInstance } from 'axios';
import { useLegalGate } from '@/composables/use-legal-gate.ts';
import { useAuthStore } from '@/stores/auth.ts';

interface ApiErrorBody {
    error: string;
    redirectTo?: string;
}
let instance: AxiosInstance | null = null;

function initializeAxios() {
    const route = useRoute();
    const router = useRouter();
    const authStore = useAuthStore();
    const gate = useLegalGate();
    instance = axios.create({
        baseURL: `${env.VITE_API_ROOT}/api/v1`,
        withCredentials: true,
        validateStatus: () => true,
    });

    instance.interceptors.response.use(async (response) => {
        const status = response.status;
        const data = response.data as ApiErrorBody | undefined;
        if (status !== 403 || data?.error !== 'legal_acceptance_required') {
            return response;
        }

        gate.requestLegalAcceptance(route.fullPath);
        const target = data?.redirectTo || '/auth/legal/accept';
        if (router.currentRoute.value.path !== target) {
            authStore.status = 'legal_required';
        }
        return response;
    });
}

export function useApiClient<T>(): ReturnType<typeof useAxios<T>> {
    if (!instance) {
        initializeAxios();
    }
    return useAxios<T>(instance as AxiosInstance);
}
